import * as React from "react";
import { makeStyles } from "@mui/styles";
import { query } from "./graph";
import { useQuery } from "@apollo/client";
import { useRouter } from "found";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";

const useStyles = makeStyles(theme => ({
  content: {
    height: "calc(100vh - 48px)"
  },

  spinnerWrapper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: "center"
  }
}));

const QaDashboardApp = () => {
  const classes = useStyles();
  const { router } = useRouter();

  // Query:
  const { data, loading, error } = useQuery(query, {
    variables: { type: "BELT" }
  });

  let productionStations = [];
  if (!loading && !error) {
    productionStations = data.productionStations;
  }

  // States:
  const [selectedProductionStationId, setSelectedProductionStationId] =
    useState(null);

  // Handlers:
  const handleSelectedProductionStationId = id => {
    setSelectedProductionStationId(id);
    router.push(`/apps/production/qa-dashboard/productionStation/${id}`);
  };

  return (
    <React.Fragment>
      {!selectedProductionStationId && (
        <div>
          {loading ? (
            <div className={classes.spinnerWrapper}>
              <CircularProgress />
            </div>
          ) : (
            productionStations.map(station => (
              <MenuItem
                id={station.id}
                button
                onClick={() => handleSelectedProductionStationId(station.id)}
              >
                {station.name}
              </MenuItem>
            ))
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default QaDashboardApp;
